import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Homepage from './components/homepage/Homepage';
import PrivacyPolicy from './components/docComponents/PrivacyPolicy'
import TermsAndConditions from './components/docComponents/TermsAndConditions';
import Contact from './components/homepage/Contact';
// import Infopage from './components/info/Infopage';
import Eula from './components/docComponents/Eula';
import ChildSafetyPolicy from './components/docComponents/ChildSafetyPolicy';
import DashPage from './components/dash/DashPage';
import PrivateRoute from './components/utils/PrivateRoute';
import './assets/styles/style.scss'


function App() {

  // Infopage when app not released
  // Homepage after release of app
  return (
    <div className="app-body">
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/termsAndConditions" element={<TermsAndConditions />} />
          <Route path="/support" element={<Contact />} />
          <Route path="/eula" element={<Eula />} />
          <Route path="/childSafetyPolicy" element={<ChildSafetyPolicy />} />
          <Route path="/myEvents" element={<PrivateRoute><DashPage /></PrivateRoute>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
